import { Skeleton } from '@sib/ui';

export const EntityActivityLogItemSkeleton = () => (
  <div className="border-border rounded-lg border bg-white p-4 shadow-sm">
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Skeleton className="size-8 shrink-0 rounded-full" />
        <Skeleton className="h-4 w-28" />
        <Skeleton className="ml-auto h-3.5 w-32" />
      </div>
      <Skeleton className="h-4 w-full max-w-md" />
      <Skeleton className="h-4 w-3/4 max-w-xs" />
    </div>
  </div>
);
